import { useMemo } from "react";
import { useProjectsList } from "./useProjectsList";
import { useFeatureFlag } from "react-migration/lib/user/useFeatureFlag";
import Feature from "src/js/stores/user/Feature";

export const useWorkspacesLimit = () => {
  const { list, loading } = useProjectsList();

  const hasUnlimitedAccess = useFeatureFlag(Feature.workspaceFull);
  const hasProAccess = useFeatureFlag(Feature.workspaceBasic);

  const limit = useMemo(() => {
    if (hasUnlimitedAccess) return 0;
    if (hasProAccess) return 3;
    return 1;
  }, [hasUnlimitedAccess, hasProAccess]);

  const limitReached = useMemo(() => {
    if (loading) return true;
    if (limit === 0) return false;
    return list.length >= limit;
  }, [list.length, limit, loading]);

  return {
    limit,
    limitReached,
    workspacesCount: list.length,
  };
};
